import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import Dispatcher from './dispatcher';
import selector from './selector';
import Utils from './utils';

const useCategories = () => {
    const dispatcher = new Dispatcher(useDispatch());
    const data = useSelector(selector, shallowEqual);
    const utils = new Utils(data, dispatcher);

    return [data, dispatcher, utils];
}

export default useCategories;